class ClientEditService {

    constructor(
        $http,
        appConfig
    ) {
        'ngInject';

        this.$http = $http;
        this.appConfig = appConfig;
    }

    /***
     * Get all of the available Client Groups.
     */
    getGroups() {
        return this.$http.get(`${this.appConfig.apiUrl}/groups/`)
            .then((successResponse) =>  successResponse.data);
    }

    /***
     * Get all of the related models that are used for dropdowns and checkboxes on the client edit page.
     */
    getRelatedModels() {
        return this.$http.get(`${this.appConfig.apiUrl}/facilities/related-fields/`)
            .then((successResponse) =>  successResponse.data);
    }

    /***
     * Update the given client.
     *
     * @param clientId          the ID of the client being updated.
     * @param updatedName       the new name for the client.
     * @param updatedGroupIds   a list of IDs of groups for the client.
     *
     * @returns {Promise}
     */
    updateClient(clientId, updatedName, updatedGroupIds) {
        const data = {
            name: updatedName,
            group_ids: updatedGroupIds
        };
        return this.$http.patch(`${this.appConfig.apiUrl}/clients/${clientId}/`, data);
    }

    /***
     * Fetch some broad metadata about the given client and its corresponding countries, campuses, and facilities.
     * These are used to populate the tree navigation on the Client Edit page.
     *
     * @param clientId      the ID of the client whose nested entities are being fetched.
     *
     * @returns {Promise}
     */
    getClientTreeView(clientId) {
        return this.$http.get(`${this.appConfig.apiUrl}/clients/${clientId}/full/`)
            .then((successResponse) =>  successResponse.data);
    }

    getCountries() {
        return this.$http.get(`${this.appConfig.apiUrl}/countries/`)
            .then((successResponse) => successResponse.data);
    }

}

export default ClientEditService;


// WEBPACK FOOTER //
// ./app/components/client-edit/client-edit-service.js